import DEAD from "@/data/deadAssets.json";

const DEAD_SET = new Set(DEAD);
const MARK = "legacy-file?u=";

// Récupère l'URL d'origine servitechxpert.com depuis une URL éventuellement réécrite par l'intercepteur.
export function pdfOriginal(url) {
  if (!url) return "";
  const i = url.indexOf(MARK);
  if (i !== -1) {
    try {
      return decodeURIComponent(url.slice(i + MARK.length));
    } catch (e) {
      return url;
    }
  }
  return url;
}

// Vrai si le PDF est un fichier supprimé de l'ancien serveur (irrécupérable) -> à masquer.
export function isDeadPdf(url) {
  return DEAD_SET.has(pdfOriginal(url));
}

// Retire du HTML de description les liens/images pointant vers un asset mort (404).
// Les liens morts deviennent du texte simple (non cliquable) ; les images mortes sont retirées.
export function stripDeadLinks(html) {
  if (!html || html.indexOf("servitechxpert.com") === -1 && html.indexOf("legacy-file") === -1) return html;
  try {
    const doc = new DOMParser().parseFromString(html, "text/html");
    doc.querySelectorAll("a[href]").forEach((a) => {
      const href = a.getAttribute("href") || "";
      if (href.indexOf("/api/files/") !== -1) return; // fichier hébergé valide
      if (isDeadPdf(href) || href.indexOf("servitechxpert.com") !== -1) {
        const span = doc.createElement("span");
        span.textContent = a.textContent;
        a.replaceWith(span);
      }
    });
    doc.querySelectorAll("img[src]").forEach((img) => {
      const src = img.getAttribute("src") || "";
      if (src.indexOf("/api/files/") !== -1) return; // image hébergée valide
      if (isDeadPdf(src) || src.indexOf("servitechxpert.com") !== -1) img.remove();
    });
    return doc.body.innerHTML;
  } catch (e) {
    return html;
  }
}

export function pdfLabel(url, idx, lang) {
  const orig = pdfOriginal(url);
  let name = "";
  try {
    name = decodeURIComponent((orig.split("?")[0].split("/").pop()) || "");
  } catch (e) {
    name = (orig.split("?")[0].split("/").pop()) || "";
  }
  name = name
    .replace(/\.pdf$/i, "")
    .replace(/[+_]+/g, " ")
    .replace(/-+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  if (!name || /^[0-9a-f]{32}$/i.test(name.replace(/\s/g, ""))) {
    return `${lang === "en" ? "Datasheet" : "Fiche technique"} ${idx + 1}`;
  }
  return name;
}
